export default "__VITE_ASSET__4ea36d26__"